var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { staticClass: "yxt-dialog__wrapper mask opa-tran yxt-o2o-media-wrap" },
        [
          _c("i", {
            staticClass:
              "yxt-icon-circle-close c-f0 font-size-32 hand pa pa-center yxt-biz-media-close",
            on: { click: _vm.close },
          }),
          _vm.showAudio
            ? _c("yxtbiz-video", {
                ref: "audio",
                staticClass: "pa pa-center",
                attrs: {
                  type: "audio",
                  options: _vm.audioOptions,
                  width: "800",
                  height: "600",
                  "play-rate": "",
                },
                on: {
                  onBeforePlay: _vm.onBeforeAudioPlay,
                  onQualityChange: _vm.onQualityAudioChange,
                  onTime: _vm.onAudioTime,
                  onError: _vm.onAudioError,
                },
              })
            : _vm._e(),
          _vm.showVideo
            ? _c("yxtbiz-video", {
                ref: "video",
                staticClass: "pa pa-center",
                attrs: {
                  type: "video",
                  options: _vm.videoOptions,
                  width: "800",
                  height: "600",
                  "play-rate": "",
                },
                on: {
                  onBeforePlay: _vm.onBeforeAudioPlay,
                  onQualityChange: _vm.onQualityAudioChange,
                  onTime: _vm.onAudioTime,
                  onError: _vm.onAudioError,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }